import {StudijnyProgram} from './studijnyProgram';

export class ZapisnyList {
  id: number;
  akademickyRok: string;
  rocnik: number;
  datumZapisu: Date;
  potvrdeny: boolean;
  elektronickyZapis: boolean;
  uzatvorenyZS: boolean;
  uzatvorenyLS: boolean;
  elektronickyZapisDate: Date;
  studijnyProgram: StudijnyProgram;
  poplatok: boolean;
  kodKruzok: string;
  eZapisAllowed: boolean;
  idStudium: number;
}
